// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"8a187b90a4661754","9341":"a1bea39ee3e587d5"}[chunkId] + ".js";
};